import {
  getFormattedDate,
  getFormattedDateTime,
  getFormattedMonthDateV2
} from "../../utils/dateTimeHelper";

import ICTempImg from "../../assets/images/noimg.png";

export function mapDoctorDetailsIncomingData(data) {
  let initData = {};

  initData._id = data._id;
  initData.uin = data.doctorId;
  initData.appDate = getFormattedDateTime(data.createdAt);
  initData.rejDate = getFormattedDateTime(data.rejectedAt);
  initData.approvalDate = getFormattedDateTime(data.approvedAt);
  initData.fname = data.firstName;
  initData.firstNameForHIService = data.firstNameForHIService;
  initData.mname = data.middleName ? data.middleName : "";
  initData.lname = data.lastName;
  initData.dob = getFormattedMonthDateV2(data.dateOfBirth);
  initData.gender = data.gender;
  initData.phoneNo = data.phoneNumber;
  initData.email = data.email;
  initData.qualifications = data.doctorQualification
    ? data.doctorQualification
    : "";
  initData.un =
    data.address.unitNumber !== null
      ? (data.address.unitNumber ? data.address.unitNumber + "/" : "") +
        data.address.streetNumber
      : data.address.streetNumber;
  initData.streetName = data.address.streetName;
  initData.suburb = data.address.suburb;
  initData.state = data.address.state;
  initData.postCode = data.address.postCode;
  initData.optOutMarketingEmails = data.optOutMarketingEmails ? true : false;

  initData.profilePic =
    data.profilePic === undefined ||
    data.profilePic === null ||
    data.profilePic === ""
      ? ICTempImg
      : data.profilePic.original;
  initData.photoId =
    data.photoId === undefined || data.photoId === null || data.photoId === ""
      ? ICTempImg
      : data.photoId.original;
  initData.abn = data.ABN ? data.ABN : "";
  initData.abnFile = data.ABN_DOC ? data.ABN_DOC : "";
  initData.abnFileName = data.ABN_DOC_NAME ? data.ABN_DOC_NAME : "";
  initData.ahp = data.AHPRA ? data.AHPRA : "";
  initData.ahpFile = data.AHPRA_DOC ? data.AHPRA_DOC : "";
  initData.ahpFileName = data.AHPRA_DOC_NAME ? data.AHPRA_DOC_NAME : "";
  initData.medProvNo = data.medicalProviderNo ? data.medicalProviderNo : "";
  initData.medProNoFile = data.medicalProviderDoc
    ? data.medicalProviderDoc
    : "";
  initData.medProNoFileName = data.medicalProviderDocName
    ? data.medicalProviderDocName
    : "";
  initData.presNo = data.prescriberNo ? data.prescriberNo : "";
  initData.pndFile = data.prescriberDoc ? data.prescriberDoc : "";
  initData.pndFileName = data.prescriberDocName ? data.prescriberDocName : "";
  initData.AUTH_PRESCRIBER_SCHEMA_DOC = data.AUTH_PRESCRIBER_SCHEMA_DOC ? data.AUTH_PRESCRIBER_SCHEMA_DOC : "";
  initData.AUTH_PRESCRIBER_SCHEMA_DOC_NAME = data.AUTH_PRESCRIBER_SCHEMA_DOC_NAME ? data.AUTH_PRESCRIBER_SCHEMA_DOC_NAME : "";

  initData.AUTH_PRESCRIBER_SCHEMA_DOC_MC = data.AUTH_PRESCRIBER_SCHEMA_DOC_MC ? data.AUTH_PRESCRIBER_SCHEMA_DOC_MC : "";
  initData.AUTH_PRESCRIBER_SCHEMA_DOC_MC_NAME = data.AUTH_PRESCRIBER_SCHEMA_DOC_MC_NAME ? data.AUTH_PRESCRIBER_SCHEMA_DOC_MC_NAME : "";

  initData.authPrescriberSchemaNo = data.authPrescriberSchemaNo ? data.authPrescriberSchemaNo : "";
  initData.authPrescriberSchemaNoMC = data.authPrescriberSchemaNoMC ? data.authPrescriberSchemaNoMC : "";
  initData.eRxId = data.eRxId ? data.eRxId : "";
  initData.eRxFile = data.eRxDoc ? data.eRxDoc : "";
  initData.eRxFileName = data.eRxDocName ? data.eRxDocName : "";
  initData.piip = data.PIIP ? data.PIIP : "";
  initData.piipdFile = data.PIIP_DOC ? data.PIIP_DOC : "";
  initData.piipdFileName = data.PIIP_DOC_NAME ? data.PIIP_DOC_NAME : "";
  initData.sigatureFile =
    data.signature === undefined ||
    data.signature === null ||
    data.signature === ""
      ? ICTempImg
      : data.signature;
  initData.ssaFile = data.SSA_DOC ? data.SSA_DOC : "";
  initData.ssaFileName = data.SSA_DOC_NAME ? data.SSA_DOC_NAME : "";
  initData.additionalApplication = data.additionalNotesApplication
    ? data.additionalNotesApplication
    : "";
  initData.addNoForDoctor = data.additionalNotesDoctor
    ? data.additionalNotesDoctor
    : "";
  if (data.templateChoices) {
    initData.template1Checkbox = data.templateChoices.generalPractices;
    initData.template2Checkbox = false;
  } else {
    initData.template1Checkbox = false;
    initData.template2Checkbox = false;
  }
  if (data.ec1) {
    initData.contactName1 =
      data.ec1.name === "" ||
      data.ec1.name === null ||
      data.ec1.name === undefined
        ? ""
        : data.ec1.name;
    initData.contactNo1 =
      data.ec1.contact === "" ||
      data.ec1.contact === null ||
      data.ec1.contact === undefined
        ? ""
        : data.ec1.contact;
  } else {
    initData.contactName1 = " ";
    initData.contactNo1 = "";
  }
  if (data.ec2) {
    initData.contactName2 =
      data.ec2.name === "" ||
      data.ec2.name === null ||
      data.ec2.name === undefined
        ? ""
        : data.ec2.name;
    initData.contactNo2 =
      data.ec2.contact === "" ||
      data.ec2.contact === null ||
      data.ec2.contact === undefined
        ? ""
        : data.ec2.contact;
  } else {
    initData.contactName2 = " ";
    initData.contactNo2 = "";
  }

  initData.rating = parseFloat(data.avgRating).toFixed(1);

  if (data.HPIIInfo) {
    initData.HPIINumber = data.HPIIInfo.HPIINumber;
    initData.HPIIStatus = data.HPIIInfo.HPIIStatus;
    initData.HPIIUpdatedAt = data.HPIIInfo.updatedAt;
  }

  initData.isAccessToInstantSwitch = data.isAccessToInstantSwitch;
  initData.isAccessToInstantHush = data.isAccessToInstantHush;
  initData.isAccessToInstantSwitchMC = data.isAccessToInstantSwitchMC;
  initData.canTakeMedicareConsult = !!data.canTakeMedicareConsult;
  initData.instantSwitchBio = data.instantXBio?.switch;
  initData.instantLeafBio = data.instantXBio?.leaf;
  initData.instantHushBio = data.instantXBio?.hush;

  console.log("Init Data: ", initData);

  // initData.pin = data.pin || "0000";
  // initData.passwordFailCounter = data.passwordFailCounter + "" || "0";

  return initData;
}

export function mapDoctorProfileSubmitData(values, doctorId) {
  let ec1 = {};
  let ec2 = {};
  let image_flag =
    values.profilePicFile !== null && values.photoIdFile !== null
      ? "true"
      : "false";
  let image_flag1 = values.photoIdFile !== null ? "true" : "false";
  let image_flag2 = values.profilePicFile !== null ? "true" : "false";

  let formData = new FormData();
  formData.append("doctor_id", doctorId);

  if (values.contactName1 && !values.contactNo1) {
    ec1.name = values.contactName1;
    formData.append("ec1", JSON.stringify(ec1));
  }
  if (!values.contactName1 && values.contactNo1) {
    ec1.contact = values.contactNo1;
    formData.append("ec1", JSON.stringify(ec1));
  }
  if (values.contactName2 && !values.contactNo2) {
    ec2.name = values.contactName2;
    formData.append("ec2", JSON.stringify(ec2));
  }
  if (!values.contactName2 && values.contactNo2) {
    ec2.contact = values.contactNo2;
    formData.append("ec2", JSON.stringify(ec2));
  }
  if (values.contactName1 && values.contactNo1) {
    ec1.name = values.contactName1;
    ec1.contact = values.contactNo1;
    formData.append("ec1", JSON.stringify(ec1));
  }
  if (values.contactName2 && values.contactNo2) {
    ec2.name = values.contactName2;
    ec2.contact = values.contactNo2;
    formData.append("ec2", JSON.stringify(ec2));
  }

  formData.append("ABN", values.abn);

  formData.append("optOutMarketingEmails", values.optOutMarketingEmails);

  if (values.abnDocFile !== null) {
    formData.append("ABN_DOC", values.abnDocFile);
  }

  formData.append("AHPRA", values.ahp);

  if (values.ahpDocFile !== null) {
    formData.append("AHPRA_DOC", values.ahpDocFile);
  }

  formData.append("medicalProviderNo", values.medProvNo);

  if (values.medProNoDocFile !== null) {
    formData.append("medicalProviderDoc", values.medProNoDocFile);
  }

  formData.append("prescriberNo", values.presNo);

  formData.append("authPrescriberSchemaNo", values.authPrescriberSchemaNo);
  formData.append("authPrescriberSchemaNoMC", values.authPrescriberSchemaNoMC);
  if (values.AUTH_PRESCRIBER_SCHEMA_DOCDoc !== null || values.AUTH_PRESCRIBER_SCHEMA_DOCDoc !== "") {
    formData.append("AUTH_PRESCRIBER_SCHEMA_DOC", values.AUTH_PRESCRIBER_SCHEMA_DOCDoc);
    formData.append("AUTH_PRESCRIBER_SCHEMA_DOC_NAME", values.AUTH_PRESCRIBER_SCHEMA_DOC_NAME);
  }

  if (values.AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC !== null || values.AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC !== "") {
    formData.append("AUTH_PRESCRIBER_SCHEMA_DOC_MC", values.AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC);
    formData.append("AUTH_PRESCRIBER_SCHEMA_DOC_NAME_MC", values.AUTH_PRESCRIBER_SCHEMA_DOC_NAME_MC);
  }

  // attach new prescriber schmea number

  if (values.pndDocFile !== null) {
    formData.append("prescriberDoc", values.pndDocFile);
  }

  formData.append("eRxId", values.eRxId);

  if (values.eRxDocFile !== null) {
    formData.append("eRxDoc", values.eRxDocFile);
  }

  formData.append("PIIP", values.piip);

  if (values.piipdDocFile !== null) {
    formData.append("PIIP_DOC", values.piipdDocFile);
  }

  if (values.additionalApplication !== "") {
    formData.append("additionalNotesApplication", values.additionalApplication);
  }

  if (values.sigatureDocFile !== null) {
    formData.append("signature", values.sigatureDocFile);
  }
  if (values.ssaDocFile !== null) {
    formData.append("SSA_DOC", values.ssaDocFile);
  }

  if (values.addNoForDoctor !== "") {
    formData.append("additionalNotesDoctor", values.addNoForDoctor);
  }

  formData.append("middleName", values.mname);

  formData.append("firstName", values.fname);
  formData.append(
    "firstNameForHIService",
    values.fnameForHIService || values.fname
  );
  formData.append("lastName", values.lname);
  formData.append("dateOfBirth", getFormattedDate(values.dob));
  formData.append("gender", values.gender);
  formData.append("doctorQualification", values.qualifications);
  formData.append("email", values.email);
  formData.append("phoneNumber", values.phoneNo);
  formData.append("streetNumber", values.un);
  formData.append("streetName", values.streetName);
  formData.append("suburb", values.suburb);
  formData.append("state", values.state);
  formData.append("postCode", values.postCode);

  if (values.profilePicFile !== null && values.photoIdFile !== null) {
    formData.append("photoIdPic", values.photoIdFile);
    formData.append("profilePhoto", values.profilePicFile);
    formData.append("isFile", image_flag);
  } else if (values.profilePicFile !== null && values.photoIdFile === null) {
    formData.append("profilePhoto", values.profilePicFile);
    formData.append("isFile", image_flag2);
  } else if (values.profilePicFile === null && values.photoIdFile !== null) {
    formData.append("photoIdPic", values.photoIdFile);
    formData.append("isFile", image_flag1);
  } else if (values.profilePicFile === null && values.photoIdFile === null) {
    formData.append("isFile", image_flag);
  }

  let tempChoices = {
    generalPractices: values.template1Checkbox,
    cosmeticsAndIv: false
  };

  formData.append("templateChoices", JSON.stringify(tempChoices));

  formData.append("isAccessToInstantSwitch", values.isAccessToInstantSwitch);
  formData.append("isAccessToInstantSwitchMC", values.isAccessToInstantSwitchMC);
  formData.append("isAccessToInstantHush", values.isAccessToInstantHush);
  formData.append("canTakeMedicareConsult", values.canTakeMedicareConsult ? true : false);

  formData.append("instantXBio[switch]", values.instantSwitchBio || "");
  formData.append("instantXBio[leaf]", values.instantLeafBio || "");
  formData.append("instantXBio[hush]", values.instantHushBio || "");


  // formData.append("pin", values.pin);
  // formData.append("passwordFailCounter", values.passwordFailCounter);

  return formData;
}
